import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import DateRangePicker from "../Reusable/DateRrangePicker";
import Modal from "../Reusable/Modal";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import NACell from "../Reusable/DataTable/NACell";
import CreateUpdateKMRecord from "./CreateUpdateKMRecord";
import TextField from "../Reusable/TextInput";
import NumberField from "../Reusable/NumberField";
import Button from "../Reusable/Button";
import usePostHook from "../../customHooks/usePostHook";
const RiderKMRecord = (props: any) => {
  const {
    setSelectedRider,
    selectedRider,
    startDate,
    endDate,
    kmRecordSetting,
  } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
    watch,
  } = useForm<any>({
    defaultValues: async () => {
      let data: any = await props?.refetch();
      return {
        ...data?.data,
        ...kmRecordSetting,
        created__range: `${startDate},${endDate}`,
      };
    },
  });
  const [openEditKMRecordPopup, setOpenEditKMRecordPopup] = useState(false);
  const [openRatePopup, setOpenRatePopup] = useState(false);
  const [selectedDate, setSelectedDate] = useState<string | null>();
  const [customDateFilter, setCustomDateFiler] = useState<any>({});
  const selectedDateRange = watch("created__range");
  const selectedDriver = watch("rider");

  useEffect(() => {
    if (selectedDateRange) {
      setCustomDateFiler({
        ...{
          start_date: selectedDateRange?.split(",")[0],
          end_date: selectedDateRange?.split(",")[1],
        },
      });
    } else {
      setCustomDateFiler({
        ...{
          start_date: null,
          end_date: null,
        },
      });
    }
  }, [selectedDateRange]);

  let defaultColumns: any = [
    {
      header: "SN",
      accessorKey: "id",
      cell: ({ row }) => row.index + 1,
    },
    {
      header: "Date",
      accessorKey: "valid_for_date",
      cell: ({ getValue }: any) => (
        <p className={tw`whitespace-nowrap`}>{getValue()}</p>
      ),
    },
    {
      header: "Start KM",
      accessorKey: "s_km",
      cell: ({ row, getValue }: any) => {
        return (
          <button
            type="button"
            onClick={() => {
              setOpenEditKMRecordPopup(true);
              setSelectedRider(row?.original);
            }}
            className={tw`focus:outline-none p-2`}
          >
            {getValue() ?? "N/A"}
          </button>
        );
      },
    },
    {
  header: "Start Location",
  accessorKey: "s_location",
  cell: ({ row }: any) => {
    const coordString = row.original.s_coordinate;
    let coord;
    try {
      coord = coordString ? JSON.parse(coordString) : null;
    } catch (err) {
      coord = null;
    }

    return coord ? (
      <button
        type="button"
        onClick={() =>
          window.open(
            `https://www.google.com/maps?q=${coord.latitude},${coord.longitude}`,
            "_blank"
          )
        }
        className={tw`focus:outline-none`}
      >
        {row.original.s_location || "N/A"}
      </button>
    ) : (
      <span>{row.original.s_location || "N/A"}</span>
    );
  },
},
    {
      header: "Start Remarks",
      accessorKey: "s_remarks",
      cell: NACell,
    },
    {
      header: "End Km",
      accessorKey: "e_km",
      cell: ({ row, getValue }: any) => {
        return (
          <button
            type="button"
            onClick={() => {
              setOpenEditKMRecordPopup(true);
              setSelectedRider(row?.original);
            }}
            className={tw`focus:outline-none p-2`}
          >
            {getValue() ?? "N/A"}
          </button>
        );
      },
    },
   {
  header: "End Location",
  accessorKey: "e_location",
  cell: ({ row }: any) => {
    const coordString = row.original.e_coordinate;
    let coord;
    try {
      coord = coordString ? JSON.parse(coordString) : null;
    } catch (err) {
      coord = null;
    }

    return coord ? (
      <button
        type="button"
        onClick={() =>
          window.open(
            `https://www.google.com/maps?q=${coord.latitude},${coord.longitude}`,
            "_blank"
          )
        }
        className={tw`focus:outline-none `}
      >
        {row.original.e_location || "N/A"}
      </button>
    ) : (
      <span>{row.original.e_location || "N/A"}</span>
    );
  },
},
    {
      header: "End Remarks",
      accessorKey: "e_remarks",
      cell: NACell,
    },
    {
      header: "Base Km",
      accessorKey: "base_km",
      cell: NACell,
    },
    {
      header: "Rate",
      accessorKey: "rate",
      cell: NACell,
    },
    {
      header: "Total Travel",
      accessorKey: "travel_distance",
      cell: NACell,
    },
    {
      header: "Amount",
      accessorKey: "total_amount",
      cell: NACell,
    },
  ];
  const { mutateAsync, isPostLoading: isAsyncloading } = usePostHook({
    queryKey: ["km-setting"],
  });

  const handleSaveRate = async (values: any, setError: any) => {
    const url = APIS.KM_RECORD_SETTING;
    const formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({
        url,
        formData,
        setError,
      });
      if (res?.status === 201) {
        setOpenRatePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Card title="Filter">
        <div className={tw`grid grid-cols-2 w-full gap-x-4 items-center`}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxInput
            url={APIS.RIDER}
            queryKey={"rider"}
            register={register("rider")}
            errors={errors?.assign_order}
            name={"rider"}
            label={"Rider"}
            setValue={setValue}
            placeholder={"Select Rider"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      </Card>
      {selectedDriver ? (
        <DataTable
          url={APIS.KM_RECORD}
          queryKey={"km-record"}
          columns={defaultColumns}
          addNewPagePath={""}
          tableName={"KM record"}
          isUpload={false}
          ratePerKm={getValues("rate_per_km")}
          baseKm={getValues("base_km")}
          params={{
            start_date: customDateFilter?.start_date ?? startDate,
            end_date: customDateFilter?.end_date ?? endDate,
            rider: selectedDriver,
          }}
          actionMenu={
            <>
              <div className={tw`w-full flex justify-end`}>
                <button
                  type="button"
                  onClick={() => setOpenRatePopup(!openRatePopup)}
                  className={tw`bg-primary-light px-4 py-2 rounded-lg focus:outline-none `}
                >
                  Rate Setting
                </button>
              </div>
            </>
          }
        />
      ) : null}

      <AccessControl
        children={
          <Modal
            isOpen={openEditKMRecordPopup}
            setIsOpen={setOpenEditKMRecordPopup}
            title={"Update KM Record"}
            children={
              <>
                <CreateUpdateKMRecord
                  setOpenEditKMRecordPopup={setOpenEditKMRecordPopup}
                  selectedRider={selectedRider}
                  selectedDate={selectedDate}
                  selectedDriver={selectedDriver}
                />
              </>
            }
          />
        }
        allowedPermissions={["can_editupdate_kmrecord"]}
      />

      <Modal
        title={"Update Rate"}
        isOpen={openRatePopup}
        setIsOpen={setOpenRatePopup}
      >
        <form onSubmit={handleSubmit((data) => handleSaveRate(data, setError))}>
          <div className={tw``}>
            <NumberField
              setValue={setValue}
              value={getValues("rate_per_km")}
              clearErrors={clearErrors}
              label={"Rate"}
              register={register("rate_per_km", {
                required: "Rate is required",
              })}
              errors={errors?.rate_per_km}
            />
            <NumberField
              setValue={setValue}
              value={getValues("base_km")}
              clearErrors={clearErrors}
              label={"Base Km"}
              register={register("base_km", {
                required: "Base Km is required",
              })}
              errors={errors?.base_km}
            />
          </div>
          <div className={tw`w-24 ml-auto`}>
            <Button label={"Save "} isLoading={isAsyncloading} />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default RiderKMRecord;
